import { render, staticRenderFns } from "./offline.vue?vue&type=template&id=2dda9fde&scoped=true&"
import script from "./offline.vue?vue&type=script&lang=js&"
export * from "./offline.vue?vue&type=script&lang=js&"
import style0 from "./offline.vue?vue&type=style&index=0&id=2dda9fde&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dda9fde",
  null
  
)

export default component.exports